import { useEffect, useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import AboutCommunity from "../components/AboutCommunity";
import MediaCarousel from "../components/MediaCarousel";
import PreSaleSection from "../components/PreSaleSection";
import SitePlan from "../components/SitePlan";
import PropertyGrid from "../components/PropertyGrid";
import PropertyModal from "../components/PropertyModal";
import Amenities from "../components/Amenities";
import LeadForm from "../components/LeadForm";
import Testimonials from "../components/Testimonials";
import TrustSection from "../components/TrustSection";
import Footer from "../components/Footer";
import WhatsAppFAB from "../components/WhatsAppFAB";
import IntroOverlay from "../components/IntroOverlay";
import FairyAmbience from "../components/FairyAmbience";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Landing() {
  const [properties, setProperties] = useState([]);
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [interestRate, setInterestRate] = useState(12);
  const [selected, setSelected] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [preselectLead, setPreselectLead] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const [propsRes, settingsRes, contentRes] = await Promise.all([
          api.get("/properties"),
          api.get("/settings"),
          api.get("/content"),
        ]);
        const sorted = (propsRes.data || []).sort((a, b) => a.lot_number - b.lot_number);
        setProperties(sorted);
        setInterestRate(settingsRes.data?.interest_rate ?? 12);
        setContent(contentRes.data || {});
      } catch {
        toast.error("No pudimos cargar los lotes");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleSelect = (p) => {
    setSelected(p);
    setModalOpen(true);
  };

  const handleRequestContact = (p) => {
    setPreselectLead(p);
    document.getElementById("contacto")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-[var(--c-bg-deep)] min-h-screen relative">
      <IntroOverlay text={content.intro_text || "Bienvenido al cuento"} />
      <FairyAmbience />
      <Header content={content} />
      <main>
        <Hero content={content} />
        <AboutCommunity content={content} />
        <MediaCarousel content={content} />
        <PreSaleSection properties={properties} onSelect={handleSelect} content={content} />
        <SitePlan properties={properties} onSelect={handleSelect} content={content} />
        <PropertyGrid properties={properties} onSelect={handleSelect} loading={loading} content={content} />
        <Amenities content={content} />
        <TrustSection content={content} />
        <Testimonials content={content} />
        <LeadForm properties={properties} preselect={preselectLead} content={content} />
      </main>
      <Footer content={content} />
      <WhatsAppFAB content={content} />

      <PropertyModal
        property={selected}
        open={modalOpen}
        onOpenChange={setModalOpen}
        interestRate={interestRate}
        onRequestContact={handleRequestContact}
      />
    </div>
  );
}
